// "Send New Outbound Email" on an account that picks a new outbound email's
// From by the order (1A_SUPPORT_EMAIL, 2026-10-06). The server decides
// (GET /api/conversations/:id's newOutbound, from
// server/src/channels/m365/config.js's m365NewOutboundAvailability()):
//   { followsOrder, available, reason, fromAddress }
// fromAddress is the brand's service@ address for the order's client (1AW ->
// service@1aauto.com, AMW -> service@am-autoparts.com). The server derives the
// real From at send time; this only shows it. Every other account has no
// newOutbound (or followsOrder false) and keeps today's behaviour.

// Whether the "Send New Outbound Email" option is disabled, and why.
export function newOutboundOption(newOutbound) {
  if (!newOutbound?.followsOrder || newOutbound.available) return { disabled: false, reason: null }
  return { disabled: true, reason: newOutbound.reason ?? 'New outbound email is unavailable for this conversation. Reply is still available.' }
}

// The From and To to show for a reply mode on such an account: a reply goes
// back to the agent who wrote in, from the mailbox itself; a new outbound
// email goes to the customer named in the body, from the brand's service@.
// null for every other account (callers keep their own seeding).
export function followsOrderAddresses(newOutbound, replyMode, { mailboxFrom = '', senderAddress = '', customerEmail = '' } = {}) {
  if (!newOutbound?.followsOrder) return null
  if (replyMode === 'new' && newOutbound.available) {
    return { from: newOutbound.fromAddress ?? '', to: customerEmail ?? '' }
  }
  return { from: mailboxFrom ?? '', to: senderAddress ?? '' }
}

// The default reply mode on such an account: a new outbound email only for an
// Invoice Request on a Website order (the reply goes to the customer); every
// other message is answered back to the agent who wrote in.
export function followsOrderDefaultReplyMode(newOutbound, intent) {
  if (!newOutbound?.followsOrder) return null
  return intent === 'invoice_request' && newOutbound.available ? 'new' : 'reply'
}
